import React, { useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import {
  updateOrderSettingModalIsVisible,
  getTimeIntervalsDate,
} from '../OrderSetting/orderSettingActions';
import { setIsForPreview, updateCartScreen } from '../Cart/cartActions';
import CartMenuSidebar from './CartMenuSidebar';
import formattedTotalCartPriceBeforeTax from '../../utils/formattedTotalCartPriceBeforeTax';
import { reviewOrder } from './utils/reviewOrderValidation';
import { createAlert } from '../Alert/alertActions';
import useIsFoodRequired from '../../customHooks/useIsFoodRequired';
import Alert from '../Alert/Alert';

const CartMenuSidebarContainer = ({
  products,
  combos,
  setIsForPreview,
  amountEditOrderConfig,
  updateOrderSettingModalIsVisible,
  orderSettingReducer,
  createAlert,
  updateCartScreen,
}) => {
  const { isFoodRequired, minFoodPrice } = useIsFoodRequired(products);
  const showReviewOrderButton = products.length > 0 || combos.length > 0;
  const {
    availableTimes,
    interPickUpDetails,
    interDeliveryDetails,
    selectedDateTime,
    orderType,
    dateTimeToShow,
    specialHours,
    interOrderType,
    interDropOffDetails,
    dropOffDetails,
  } = orderSettingReducer;

  useEffect(() => {
    setIsForPreview(true);
    updateCartScreen('menu');
  }, []);

  const deliveryBusiness =
    interDeliveryDetails && interDeliveryDetails.deliveryBusiness
      ? interDeliveryDetails.deliveryBusiness
      : null;

  return (
    <CartMenuSidebar
      createAlert={createAlert}
      products={products}
      showReviewOrderButton={showReviewOrderButton}
      totalCartPriceBeforeTax={formattedTotalCartPriceBeforeTax(
        products,
        combos
      )}
      isFoodRequired={isFoodRequired}
      minFoodPrice={minFoodPrice}
      updateCartScreen={updateCartScreen}
      reviewOrder={() =>
        reviewOrder({
          amountEditOrderConfig,
          orderType,
          interPickUpDetails,
          interDeliveryDetails,
          deliveryBusiness,
          selectedDateTime,
          availableTimes,
          dateTimeToShow,
          updateOrderSettingModalIsVisible,
          specialHours,
          interPickUpDetails,
          interDeliveryDetails,
          interDropOffDetails,
          dropOffDetails,
        })
      }
    />
  );
};

const mapStateToProps = (state) => ({
  products: state.cartReducer.products,
  combos: state.cartReducer.combos,
  locations: state.locationsReducer.locations,
  orderSettingReducer: state.orderSettingReducer,
  amountEditOrderConfig: state.orderSettingReducer.amountEditOrderConfig,
});

export default connect(mapStateToProps, {
  setIsForPreview,
  updateOrderSettingModalIsVisible,
  getTimeIntervalsDate,
  updateCartScreen,
  createAlert: (props) => createAlert(props),
})(CartMenuSidebarContainer);
